
import { show } from '@/api/upgrades'
import DataForm from './components/DataForm.vue'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    DataForm
  }
})

export default class extends Vue {
  model: Record<string, any> = {}

  async created () {
    const { data } = await show(parseInt(this.$route.params.id))
    data.items = data.items.join('\n')
    this.model = data
  }
}
